import { render, staticRenderFns } from "./not-project.vue?vue&type=template&id=e093f224&scoped=true&"
import script from "./not-project.vue?vue&type=script&lang=js&"
export * from "./not-project.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e093f224",
  null
  
)

export default component.exports